export const getIdFromUrl = (state, props) => props.routeParams.id
